var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Tooltip } from '../Tooltip';
import { Stack } from '../Stack';
import { Icon } from '../Icon';
export const Label = (_a) => {
    var { action, children, className, direction, disabled, error, help, optional, required } = _a, props = __rest(_a, ["action", "children", "className", "direction", "disabled", "error", "help", "optional", "required"]);
    const getRequiredOptional = () => {
        const optionalUI = '(optional)';
        const requiredUI = '*';
        return required ? (React.createElement("span", { className: "Label__required" }, requiredUI)) : optional ? (React.createElement("span", { className: "Label__optional" }, optionalUI)) : undefined;
    };
    const getLabelHelp = () => {
        if (help === undefined || help === '')
            return false;
        if (typeof help === 'string') {
            return (React.createElement(Tooltip, { text: help, direction: direction, onClick: preventControlFocus, portal: true },
                React.createElement(Icon, { className: "Label__help", name: "help", size: "18" })));
        }
        return help;
    };
    /* If Label is in a <label>, it typically brings focus to another element. This function prevents this. */
    const preventControlFocus = (e) => {
        e.stopPropagation();
    };
    const LabelClasses = classnames('Label', className, {
        'Label--error': error,
        'Label--disabled': disabled,
    });
    return (React.createElement(Stack, Object.assign({ className: LabelClasses, "data-anvil-component": "Label" }, props),
        React.createElement(Stack.Item, { fill: true },
            children,
            getRequiredOptional(),
            getLabelHelp()),
        React.createElement("span", { className: "Label__action", onClick: preventControlFocus }, action)));
};
//# sourceMappingURL=Label.js.map